// src/components/Swap/CashSwap.js

import React from 'react'; // eslint-disable-line no-unused-vars

/* 
// ==================== ORIGINAL CASHSWAP COMPONENT ====================

// import React, { useState, useContext, useEffect, useRef, useCallback } from 'react';
// import { ethers } from 'ethers';
// import { MiningContext } from '../../context/MiningContext';
// import { toast } from 'react-toastify';
// import '../../App.css';
// import { CircularProgress, Button, TextField, Typography, Box, IconButton, Modal } from '@mui/material';
// import SettingsIcon from '@mui/icons-material/Settings';
// import { BalanceContext } from '../../context/BalanceContext';
// import { WalletContext } from '../../context/WalletContext';
// import { loadCashSwapContract } from '../../utils/loadBlockchain';
// import xLogo from '../../assets/xlogo.svg';
// import { NETWORK_CONFIG, WETH9_ADDRESS, UNISWAP_QUOTER_ADDRESS } from '../../contracts/constants';

// const formatTime = (seconds) => {
//   if (seconds <= 0) return "Expired";
//   const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
//   const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
//   const s = (seconds % 60).toString().padStart(2, '0');
//   return `${h}:${m}:${s}`;
// };

// const CashSwap = () => {
//   const { account, provider } = useContext(WalletContext);
//   const { miningEventStatus } = useContext(MiningContext);
//   const { nativeBalance, fetchNativeBalance } = useContext(BalanceContext);
//   const [amountIn, setAmountIn] = useState('');
//   const [cashBalance, setCashBalance] = useState('0');
//   const [totalSwaps, setTotalSwaps] = useState(0);
//   const [userSwaps, setUserSwaps] = useState(0);
//   const [loading, setLoading] = useState(false);
//   // Default slippage is set to 5%
//   const [slippage, setSlippage] = useState(5);
//   const [showShareModal, setShowShareModal] = useState(false);
//   const [showSlippageModal, setShowSlippageModal] = useState(false);
//   const [timeLeft, setTimeLeft] = useState(null);
//   const [contractStartTime, setContractStartTime] = useState(null);

//   const cashSwapContractRef = useRef(null);

//   // Fetch user balances and swap statistics
//   const fetchBalancesAndStats = useCallback(async () => {
//     if (!provider || !account) return;
//     try {
//       await fetchNativeBalance();
//       const cashSwapContract = cashSwapContractRef.current;
//       if (!cashSwapContract) {
//         toast.error('CashSwap contract not initialized.');
//         return;
//       }
//       const cashTokenAddress = await cashSwapContract.CASH();
//       if (!ethers.utils.isAddress(cashTokenAddress) || cashTokenAddress === ethers.constants.AddressZero) {
//         toast.error('Invalid CASH token address.');
//         return;
//       }
//       const cashTokenContract = new ethers.Contract(
//         cashTokenAddress,
//         ["function balanceOf(address) view returns (uint256)"],
//         provider
//       );
//       const code = await provider.getCode(cashTokenAddress);
//       if (code === '0x') {
//         toast.error('CASH token contract not found.');
//         return;
//       }
//       const balance = await cashTokenContract.balanceOf(account);
//       setCashBalance(ethers.utils.formatUnits(balance, 18));
//       const userSwapCount = await cashSwapContract.userSwaps(account);
//       const totalSwapCount = await cashSwapContract.totalSwaps();
//       setUserSwaps(userSwapCount.toNumber());
//       setTotalSwaps(totalSwapCount.toNumber());
//     } catch (error) {
//       if (error.code !== 'CALL_EXCEPTION') {
//         toast.error('Failed to fetch balances or statistics.');
//       }
//       console.error('Error in fetchBalancesAndStats:', error);
//     }
//   }, [provider, account, fetchNativeBalance]);

//   /**
//    * Handles the swap action.
//    *
//    * We attempt to use the Uniswap V3 Quoter (via callStatic) to get an expected output,
//    * apply a 5% slippage tolerance, and pass that as amountOutMinimum.
//    * If the quoter call fails, we set amountOutMinimum to 0.
//    *
//    * We also use a fixed gas limit of 600,000 to bypass the unpredictable gas estimation.
//    */
//   const handleSwap = useCallback(async () => {
//     if (!provider || !account) {
//       toast.error('Please connect your wallet.');
//       return;
//     }
//     if (!miningEventStatus.finalized) {
//       toast.error('Cash Swap is currently disabled until the mining event is finalized.');
//       return;
//     }
//     if (!amountIn || isNaN(amountIn) || parseFloat(amountIn) <= 0) {
//       toast.warn('Please enter a valid amount of ETH to swap.');
//       return;
//     }

//     try {
//       setLoading(true);
//       const amountInWei = ethers.utils.parseEther(amountIn);
//       if (amountInWei.lte(0)) throw new Error('Amount must be greater than 0');

//       // Ensure the CashSwap contract is initialized and get the CASH token address.
//       const cashSwapContract = cashSwapContractRef.current;
//       if (!cashSwapContract) {
//         toast.error('CashSwap contract not initialized.');
//         return;
//       }
//       const tokenOutAddress = await cashSwapContract.CASH();
//       const poolFee = 3000; // 0.3% fee tier

//       // Verify pool existence using the Uniswap V3 Factory.
//       const factoryABI = ["function getPool(address tokenA, address tokenB, uint24 fee) external view returns (address)"];
//       const factoryAddress = "0x1f98400000000000000000000000000000000003";
//       const factory = new ethers.Contract(factoryAddress, factoryABI, provider);
//       const poolAddress = await factory.getPool(WETH9_ADDRESS, tokenOutAddress, poolFee);
//       if (!poolAddress || poolAddress.toLowerCase() !== "0x31a58f678e0f2584098633bc0d5feec5b38b7f60".toLowerCase()) {
//         toast.error("Pool not found or liquidity issue.");
//         return;
//       }

//       // Set up the quoter contract with the QuoterV2 ABI.
//       const quoterABI = [
//         "function quoteExactInputSingle(address tokenIn, address tokenOut, uint24 fee, uint256 amountIn, uint160 sqrtPriceLimitX96) external returns (uint256 amountOut, uint256 sqrtPriceX96After, uint256 initializedTicksCrossed, uint256 feeAmount)"
//       ];
//       const quoter = new ethers.Contract(UNISWAP_QUOTER_ADDRESS, quoterABI, provider);

//       let quotedAmountOut;
//       try {
//         // Try to get a quote using a generous gas override.
//         const [amountOut] = await quoter.callStatic.quoteExactInputSingle(
//           WETH9_ADDRESS,
//           tokenOutAddress,
//           poolFee,
//           amountInWei,
//           0,
//           { gasLimit: 1_000_000 }
//         );
//         quotedAmountOut = amountOut;
//       } catch (quoteError) {
//         console.error("Quote error:", quoteError);
//         quotedAmountOut = ethers.BigNumber.from(0);
//         toast.error("Failed to fetch swap quote – falling back to 0 minimum output.");
//       }

//       // Apply 5% slippage tolerance if a quote was obtained; otherwise, set minimum to 0.
//       const amountOutMinimum = quotedAmountOut.gt(0)
//         ? quotedAmountOut.mul(95).div(100)
//         : ethers.BigNumber.from(0);

//       const signer = provider.getSigner();
//       const cashSwapContractWithSigner = cashSwapContract.connect(signer);

//       // Use a fixed gas limit (600,000) to bypass unpredictable gas estimation.
//       const gasLimit = ethers.BigNumber.from("600000");

//       const swapTx = await cashSwapContractWithSigner.swapExactInputSingle(
//         amountOutMinimum,
//         { value: amountInWei, gasLimit }
//       );

//       toast.info('Swap transaction sent. Awaiting confirmation...');
//       const receipt = await swapTx.wait();
//       if (receipt.status === 1) {
//         toast.success('Swap successful!');
//         setAmountIn('');
//         await fetchBalancesAndStats();
//         setShowShareModal(true);
//       } else {
//         throw new Error('Transaction failed');
//       }
//     } catch (error) {
//       if (
//         error.code === 4001 ||
//         error.code === 'ACTION_REJECTED' ||
//         (error.message && error.message.toLowerCase().includes('user rejected')) ||
//         (error.message && error.message.toLowerCase().includes('user denied')) ||
//         (error.data && error.data.code === 'ACTION_REJECTED')
//       ) {
//         return;
//       }
//       let errorMessage = 'Swap failed: ';
//       if (error.data) {
//         try {
//           const bytes = ethers.utils.arrayify(error.data);
//           const decoded = ethers.utils.defaultAbiCoder.decode(['string'], bytes);
//           errorMessage += decoded[0];
//         } catch (e) {
//           errorMessage += error.message || 'Unknown error occurred';
//         }
//       } else {
//         errorMessage += error.message || 'Unknown error occurred';
//       }
//       toast.error(errorMessage);
//       console.error('Error in handleSwap:', error);
//     } finally {
//       setLoading(false);
//     }
//   }, [amountIn, provider, account, miningEventStatus, fetchBalancesAndStats]);

//   useEffect(() => {
//     const initializeContract = async () => {
//       if (!provider || !account) return;
//       try {
//         const contract = await loadCashSwapContract(provider);
//         if (!contract) throw new Error('Failed to load CashSwap contract');
//         cashSwapContractRef.current = contract;
//         const startTime = await contract.swapContractStartTime();
//         setContractStartTime(startTime.toNumber());
//         await fetchBalancesAndStats();
//       } catch (error) {
//         toast.error('Error initializing contract.');
//         console.error('Error initializing CashSwap contract:', error);
//       }
//     };
//     initializeContract();
//   }, [provider, account, fetchBalancesAndStats]);

//   useEffect(() => {
//     if (!contractStartTime) return;
//     const deadline = contractStartTime + (3 * 24 * 60 * 60); // 3 days in seconds
//     const updateTimeLeft = () => {
//       const now = Math.floor(Date.now() / 1000);
//       const remaining = deadline - now;
//       setTimeLeft(remaining > 0 ? remaining : 0);
//     };
//     updateTimeLeft();
//     const timer = setInterval(updateTimeLeft, 1000);
//     return () => clearInterval(timer);
//   }, [contractStartTime]);

//   const handlePercentageClick = useCallback(
//     (percentage) => {
//       if (nativeBalance && !isNaN(nativeBalance)) {
//         const value = (parseFloat(nativeBalance) * percentage).toFixed(4);
//         setAmountIn(value);
//       }
//     },
//     [nativeBalance]
//   );

//   const handleAmountChange = useCallback((e) => {
//     const value = e.target.value.replace(',', '.');
//     setAmountIn(value);
//   }, []);

//   const ShareOnXModal = React.memo(({ onClose, userSwaps, txHash }) => {
//     const shareText = encodeURIComponent(
//       `I swapped ${userSwaps} times for $CASH 💸\n\n@_CASHisDEAD_\n${NETWORK_CONFIG.bridgeUrl}`
//     );
//     const shareUrl = `https://twitter.com/intent/tweet?text=${shareText}`;
//     const followUrl = 'https://twitter.com/_CASHisDEAD_';
//     const modalRef = useRef();
//     const handleClickOutside = useCallback(
//       (e) => {
//         if (modalRef.current && !modalRef.current.contains(e.target)) {
//           onClose();
//         }
//       },
//       [onClose]
//     );
//     useEffect(() => {
//       document.addEventListener('mousedown', handleClickOutside);
//       return () => {
//         document.removeEventListener('mousedown', handleClickOutside);
//       };
//     }, [handleClickOutside]);
//     const handleClose = (e) => {
//       e.stopPropagation();
//       onClose();
//     };
//     const handleViewOnExplorer = (txHash) => {
//       if (txHash) window.open(`${NETWORK_CONFIG.blockExplorer}/tx/${txHash}`, '_blank');
//     };
//     return (
//       <div className="modal-overlay">
//         <div className="modal-content" ref={modalRef}>
//           <button
//             className="modal-close-button"
//             onClick={handleClose}
//             onAuxClick={() => handleViewOnExplorer(txHash)}
//             aria-label="Close Modal"
//           >
//             &times;
//           </button>
//           <div className="share-on-x-prompt">
//             <img src={xLogo} alt="Share on X" className="share-logo" />
//             <span className="share-message">Share your swap on X!</span>
//             <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px' }}>
//               <a href={shareUrl} target="_blank" rel="noopener noreferrer" className="share-button">
//                 <Button variant="contained" color="primary">Share</Button>
//               </a>
//               <a href={followUrl} target="_blank" rel="noopener noreferrer" className="follow-button">
//                 <Button variant="outlined" color="secondary">Follow</Button>
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   });

//   const SlippageModal = () => (
//     <Modal open={showSlippageModal} onClose={() => setShowSlippageModal(false)}>
//       <Box
//         sx={{
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           width: 300,
//           bgcolor: 'background.paper',
//           borderRadius: 2,
//           p: 3,
//           boxShadow: 24,
//         }}
//       >
//         <Typography variant="h6" mb={2}>Slippage</Typography>
//         <TextField
//           type="number"
//           value={slippage}
//           onChange={(e) => setSlippage(e.target.value)}
//           fullWidth
//           inputProps={{ step: '0.1', min: '0.1', max: '5' }}
//         />
//         <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
//           <Button variant="contained" onClick={() => setShowSlippageModal(false)}>Save</Button>
//         </Box>
//       </Box>
//     </Modal>
//   );

//   return (
//     <div className="swap-container">
//       <Typography 
//         variant="h4" 
//         gutterBottom 
//         className="title-glow"
//         sx={{
//           fontWeight: 700,
//           letterSpacing: '0.1rem',
//           textAlign: 'center',
//           textTransform: 'uppercase',
//           mb: 3,
//           fontFamily: 'var(--font-primary)',
//           fontSize: '2.5rem'
//         }}
//       >
//         $CASH Swap
//       </Typography>

//       <Box className="swap-input-section">
//         <TextField
//           label="Amount of ETH"
//           type="number"
//           value={amountIn}
//           onChange={handleAmountChange}
//           fullWidth
//           inputProps={{
//             min: '0',
//             step: '0.0001',
//             style: { 
//               textAlign: 'left',
//               paddingRight: '45px'
//             }
//           }}
//           disabled={!miningEventStatus.finalized}
//         />
//         <IconButton
//           onClick={() => setShowSlippageModal(true)}
//           className="cog-icon"
//           aria-label="Slippage Settings"
//           sx={{
//             position: 'absolute',
//             right: '12px',
//             top: '50%',
//             transform: 'translateY(-50%)',
//             padding: '4px',
//             minWidth: '24px',
//             minHeight: '24px',
//             width: '24px',
//             height: '24px',
//             borderRadius: '4px',
//             overflow: 'hidden',
//             '& .MuiSvgIcon-root': {
//               width: '16px',
//               height: '16px',
//               color: 'var(--primary-color)',
//               transition: 'color 0.2s ease'
//             },
//             '&:hover': {
//               background: 'transparent',
//               '& .MuiSvgIcon-root': {
//                 color: 'var(--accent-color)'
//               }
//             },
//             '&::before': {
//               content: '""',
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               borderRadius: '4px',
//               pointerEvents: 'none'
//             }
//           }}
//         >
//           <SettingsIcon />
//           <span className="slippage-tooltip">Slippage</span>
//         </IconButton>
//       </Box>

//       {showSlippageModal && (<SlippageModal />)}

//       <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 2 }}>
//         <Button
//           className="percentage-button"
//           variant="outlined"
//           size="small"
//           onClick={() => handlePercentageClick(0.5)}
//           disabled={!miningEventStatus.finalized}
//         >
//           50%
//         </Button>
//         <Button
//           className="percentage-button"
//           variant="outlined"
//           size="small"
//           onClick={() => handlePercentageClick(1)}
//           disabled={!miningEventStatus.finalized}
//         >
//           Max
//         </Button>
//       </Box>

//       <Typography variant="caption" color="white" sx={{ mt: 2, display: 'block' }}>
//         ETH Balance: {nativeBalance && !isNaN(nativeBalance) ? `${parseFloat(nativeBalance).toFixed(2)} ` : 'Loading...'}
//       </Typography>

//       <Button
//         variant="contained"
//         color="primary"
//         onClick={handleSwap}
//         disabled={!amountIn || loading || !miningEventStatus.finalized}
//         fullWidth
//       >
//         {loading ? <CircularProgress size={24} color="inherit" /> : 'Swap'}
//       </Button>

//       <Typography className="cash-balance" variant="caption" color="white" sx={{ mt: 2 }}>
//         $CASH Balance: {cashBalance && !isNaN(cashBalance) ? `${parseFloat(cashBalance).toFixed(2)} ` : 'Loading...'}
//       </Typography>

//       <Box className="swap-stats-container" sx={{ mt: 3 }}>
//         <Typography variant="body2">Total Swaps: {totalSwaps}</Typography>
//         {account && <Typography variant="body2">My Swaps: {userSwaps}</Typography>}
//         {timeLeft !== null && timeLeft > 0 && (
//           <Typography 
//             variant="caption" 
//             color="primary" 
//             sx={{ 
//               fontSize: '0.7rem', 
//               mt: 1, 
//               textAlign: 'center', 
//               display: 'block',
//               fontWeight: 'bold'
//             }}
//           >
//             ⏰ Earn OG Swapper NFT: {formatTime(timeLeft)}
//           </Typography>
//         )}
//       </Box>

//       {showShareModal && <ShareOnXModal onClose={() => setShowShareModal(false)} userSwaps={userSwaps} txHash={''} />}
//     </div>
//   );
// };

// export default CashSwap;


// ==================== DISABLED CASHSWAP COMPONENT ====================

const CashSwap = () => {
  return null;
};

export default CashSwap;